import { Base } from "../../framework/base";
import { ListItems } from "../../framework/listItems";
import { IWhistleBlowEditItemMessage, WhistleBlowEditItemMessage } from "./whistleBlowEditItemMessage";

export interface IWhistleBlowEditItemMessages extends ListItems<IWhistleBlowEditItemMessage> {
}

export class WhistleBlowEditItemMessages extends ListItems<WhistleBlowEditItemMessage> implements IWhistleBlowEditItemMessages {
    constructor();
    constructor(obj: IWhistleBlowEditItemMessage);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, WhistleBlowEditItemMessage);
    }
}